import React from 'react';
import { Avatar } from '@socialchorus/shared-ui-components';
import { AssistantAction } from '../../assistant';
import { AvatarCard } from '../../../models/chatbot/types';
import { convertToActionable } from '../../../lib/action-utils';
import { noop } from '../noop';

interface AvatarRefCardProps {
  card: AvatarCard;
  onClick?: () => void;
}

const AvatarRefCard: React.FC<AvatarRefCardProps> = ({ card, onClick }) => {
  const actionable = convertToActionable(card.action, card.heading);

  return (
    <AssistantAction
      action={actionable}
      className="ai-content__reference-card"
      onClick={onClick || noop}
    >
      <div className="ai-content__reference-card-content">
        <div className="ai-content__reference-card-body">
          <div className="ai-content__reference-avatar">
            <Avatar
              alt={card.avatar.alt_text}
              size="medium"
              shape="circle"
              imgSrc={card.avatar.url || undefined}
            />
          </div>
          <div className="ai-content__reference-text">
            <h4 className="ai-content__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="ai-content__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </AssistantAction>
  );
};

export default AvatarRefCard;
